(function () {

    "use strict";

    angular.module('harriApp')
        .controller("InviteToApplyModal", InviteToApplyModalController);

    InviteToApplyModalController.$inject = ['$scope', 'hUser', '$stateParams', 'modalData', 'hFormsService', 'inviteToApplyDataService', '$state', 'hEvent','brandServices'];

    function InviteToApplyModalController($scope, hUser, $stateParams, modalData, hFormsService, inviteToApplyDataService, $state, hEvent, brandServices) {
        var self = this;

        self.jobNotSelected = false;
        self.data = {};

        var selectedBrand;
        self.brandId = modalData.brandId;
        self.candidates = modalData.candidates;
        self.source = modalData.source || null;
        self.invalidCandidates = false;
        self.inviting = false;

        self.data.candidates = angular.copy(self.candidates);

        self.inviteToApplyMsgForm = hFormsService.getFormInstance("InviteToApplyMsgForm", "invite-to-apply-msg-form", $scope);
        self.inviteToApplyMsgForm.loadData({
            brandId: self.brandId
        });

        const selectActiveJobForm = hFormsService.getForm("selectActiveJobForm");
        self.selectActiveJobForm = new selectActiveJobForm($scope, 'select-active-job-form');
        self.selectActiveJobForm.load({
            brandId: self.brandId, onJobChanged: (data) => {
                self.onJobSelected(data)
            }
        });

        self.onSelectedCandidatesChanged = function () {
            self.invalidCandidates = !(self.data && self.data.candidates && self.data.candidates.length);
            selectedBrand && checkBrandBalance(selectedBrand);
        };

        self.tabs = {
            JOB_SELECT: {
                id: "JOB_SELECT",
                active: true,
                done: false
            },
            MESSAGE_TEMPLATE: {
                id: "MESSAGE_TEMPLATE",
                active: false,
                done: false
            }
        };

        self.close = function () {
            modalData.onHide && modalData.onHide();
            $scope.$hide();
        };

        self.navigate = async (tab) => {
            if (self.tabs[tab].active) {
                return;
            }
            if (self.tabs.JOB_SELECT.active) {
                let res = await self.selectActiveJobForm.save();
                if (res) {
                    self.tabs.JOB_SELECT.done = true;
                    self.tabs.JOB_SELECT.active = false;
                    self.tabs.JOB_SELECT.hasError = false;
                    self.tabs.MESSAGE_TEMPLATE.active = true;
                } else {
                    self.tabs.JOB_SELECT.hasError = true;
                }
                $scope.$digest();
            } else {
                self.tabs.MESSAGE_TEMPLATE.done = false;
                self.tabs.JOB_SELECT.done = false;
                self.tabs.MESSAGE_TEMPLATE.active = false;
                self.tabs.JOB_SELECT.active = true;
            }
        };

        self.onJobSelected = function (data) {
            self.balanceChecked = false;
            self.data = self.data || {};
            self.data.job = data.job;
            self.jobNotSelected = !self.data || !self.data.job;
            if (!selectedBrand || (selectedBrand.id !== data.brand.id)) {
                selectedBrand = data.brand;
                checkBrandBalance(selectedBrand);
                self.inviteToApplyMsgForm.loadBrandTemplates(selectedBrand);
            }
        };

        var checkBrandBalance = function (brand) {
            self.loadingBalance = true;
            inviteToApplyDataService.getBrandBalance(brand.id)
                .then(function (res) {
                    self.candidatesBalance = (res.brand_balance && res.brand_balance[0].candidate_balance) || 0;
                    self.hasEnoughCredits = self.candidatesBalance >= self.data.candidates.length;
                    self.balanceChecked = true;
                }, function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.loadingBalance = false;
                });
        };

        self.buyMoreCredits = function () {
            //TODO save candidate and job to retrieve them like the old modal
            console.log('TODO here');
            $state.go('pricing');
            self.close();
        };

        self.invite = function () {
            self.inviting = true;
            self.inviteToApplyMsgForm.validateThenGetData()
                .then(function (data) {

                    var jobId = self.data.job.id;
                    var candidateIds = _.pluck(self.data.candidates, "id");
                    var subject = data.subject;
                    var message = data.body;
                    const brandId = hUser.getUserContext().brand_id;

                    inviteToApplyDataService.sendJobApplyInvitationToCandidates(jobId, candidateIds, subject, message, brandId, self.source)
                        .then(function (res) {
                            hEvent.track(
                                'invite_candidates_to_apply',
                                {
                                    'candidates_ids': candidateIds,
                                    'job_id': jobId,
                                    'page': $state.current.name
                                },
                                function () {
                                }
                            );
                            self.inviting = false;
                            handleAlertMsg(res);
                            self.close();
                        }, function (err) {
                            self.inviting = false;
                            console.error(err);
                            if (err.status === 412) {
                                noCreditsCallback();
                            } else if (err.data.status_code === 403) {
                                hAlert(
                                    $filter("translate")("Error"),
                                    $filter("translate")("You don’t have the sufficient privileges to perform this operation"),
                                    function () {
                                        var path;
                                        if (hUser.isTopLevelContext()) {
                                            path = "appLayout.harriSH.access-portal.main";
                                        } else {
                                            path = "appLayout.harriSH.dashboard";
                                        }
                                        Utils.redirectToWorkspace(path);
                                    }
                                );
                            }
                        });
                }, function (err) {
                    self.inviting = false;
                    console.error(err);
                });
        };

        var noCreditsCallback = function () {
            hConfirm({
                title: $filter("translate")("Invite To Apply"),
                text: $filter("translate")("You don't have enough credits available to complete this action. Add more credits now"),
                confirmButton: $filter('translate')('Buy Credits'),
                callback: function (confirmed) {
                    if (confirmed) {
                        self.buyMoreCredits();
                    }
                }
            });
        };

        var handleAlertMsg = function (res) {
            var text = '';
            var member;

            /* already invited candidates */
            if (res.already_invited && res.already_invited.length) {
                text += $filter("translate")("You have already invited these candidates to apply:");
                text += '<ul>';
                _.each(res.already_invited, function (val, index) {
                    member = _.findWhere(self.candidates, {id: val});
                    text += "<li class='h-text bold normal'>" + member.firstName + " " + member.lastName + "</li>";
                });
                text += '</ul>';
            }

            /* already applied candidates */
            if (res.already_applied && res.already_applied.length) {
                text += $filter("translate")("These candidates have already applied to this position:");
                text += '<ul>';
                _.each(res.already_applied, function (val, index) {
                    member = _.findWhere(self.candidates, {id: val});
                    text += "<li class='h-text bold normal'>" + member.firstName + " " + member.lastName + "</li>";
                });
                text += '</ul>';
            }

            /* invited candidates */
            if (res.invited && res.invited.length) {
                text += $filter("translate")("The following candidates were successfully invited to apply:");
                text += '<ul>';
                _.each(res.invited, function (val, index) {
                    member = _.findWhere(self.candidates, {id: val});
                    text += "<li class='h-text bold normal'>" + member.firstName + " " + member.lastName + "</li>";
                });
                text += '</ul>';
            }

            hAlert($filter('translate')('Invite to apply'), text);
        };

        var init = function () {

            var brandId;

            if (hUser.isTopLevelContext()) {
                if ($stateParams['brandId']) {
                    brandId = parseInt($stateParams['brandId']);
                }
                else {
                    brandId = hUser.getUserContext().brand_id;
                }
            }
            else {
                var brandsList = hUser.data.user.brands_list || [];
                brandId = brandsList[0] && brandsList[0].id;
            }

            brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, brandId)
                .then(function (res) {
                    self.isGTPServiceEnabled = res;
                }, function (err) {
                    console.error(err);
                });
        };

        init();
    }

})();
